import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { getProfessions, Profession } from "../redux/professionAction";
import { useTranslation } from "react-i18next";
import getTranslatedProfessionName from "../../utils/getTranslatedProfessionName";

interface ProfessionSelectProps {
    value: Profession[];
    onChange: (value: Profession[]) => void;
    label?: string;
    multiple?: boolean;
    required?: boolean;
    sx?: any;
    name?: string;
}

export default function ProfessionSelect({
    value,
    onChange,
    sx,
    multiple = true,
    required = false,
    name,
}: ProfessionSelectProps) {
    const [options, setOptions] = useState<Profession[]>([]);
    const [loading, setLoading] = useState(true);
    const { t, i18n } = useTranslation();

    useEffect(() => {
        getProfessions()
            .then((data) => {
                setOptions(data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, []);

    return (
        <Autocomplete
            freeSolo={false}
            multiple={multiple}
            disablePortal
            loading={loading}
            options={options}
            value={value}
            getOptionLabel={({ name, translations }) =>
                translations?.[i18n.language] || name
            }
            onChange={(e, newValue) =>
                onChange(
                    Array.isArray(newValue)
                        ? newValue
                        : newValue
                        ? [newValue]
                        : []
                )
            }
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
                <TextField
                    sx={sx}
                    {...params}
                    required={required}
                    label={t("inputLabels.profession")}
                    placeholder={t("inputPlaceholders.selectProfession")}
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading && <CircularProgress size={20} />}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    name={name}
                />
            )}
        />
    );
}
